module.exports = __webpack_public_path__ + "static/media/bvd1.03e2b761.jpg";